export var menu = [
    {
        title: "Product",
        groups: [
            {
                items: [
                    {
                        title: "Product Overview",
                        path: ""
                    },
                    {
                        title: "Apps & Integrations",
                        path: "/marketplace/"
                    },
                    {
                        title: "Templates",
                        path: "/templates/"
                    },
                    {
                        title: "Miroverse",
                        path: "/miroverse/"
                    },
                    {
                        title: "Miro Developer Platform",
                        path: ""
                    },
                    {
                        title: "Miro for Devices",
                        path: "/apps/"
                    },
                    {
                        title: "Security & Compliance",
                        path: "/security/"
                    },
                    {
                        title: "Changelog",
                        path: "/changelog/"
                    },
                    {
                        title: "Accessibility",
                        path: "/accessibility-statement/"
                    }, 
                ],
                viewAllLink: {
                    title: "View demo",
                    path: ""
                }
            }, 
        ]
    },
    {
        title: "Solutions",
        groups: [
            {
                items: [
                    {
                        title: "Meetings and Workshops",
                        path: "/meetings-and-workshops/"
                    },
                    {
                        title: "Brainstorming & Ideation",
                        path: "/online-brainstorm-tool/"
                    },
                    {
                        title: "Agile Workflows",
                        path: "/online-scrum-agile-tool/"
                    },
                    {
                        title: "Mapping & Diagramming",
                        path: "/online-diagram-and-map-maker/"
                    },
                    {
                        title: "Research & Design",
                        path: "/online-canvas-for-design/"
                    },
                    {
                        title: "Strategy & Planning",
                        path: "/online-strategic-planning-tool/"
                    }, 
                ]
            }, 
        ]
    },
    {
        title: "Resources",
        groups: [
            {
                items: [
                    {
                        title: "Miro Academy",
                        path: "https://academy.miro.com/"
                    },
                    {
                        title: "Help Center",
                        path: "https://help.miro.com/hc/en-us"
                    },
                    {
                        title: "Blog",
                        path: "https://miro.com/blog/"
                    },
                    {
                        title: "Status",
                        path: "https://status.miro.com/"
                    },
                    {
                        title: "Miro Community",
                        path: "https://community.miro.com/"
                    },
                    {
                        title: "Miro Experts",
                        path: "https://miro.com/experts/"
                    },
                    {
                        title: "Miro Events",
                        path: "https://events.miro.com/"
                    }, 
                ]
            }, 
        ]
    },
    {
        title: "Company",
        groups: [
            {
                items: [
                    {
                        title: "About us",
                        path: "/about/"
                    },
                    {
                        title: "Careers \uD83D\uDE80",
                        path: "/careers/"
                    },
                    {
                        title: "Miro in the News",
                        path: ""
                    },
                    {
                        title: "Customer Stories",
                        path: ""
                    }, 
                ]
            }, 
        ]
    },
    {
        title: "Plans and Pricing",
        groups: [
            {
                items: [
                    {
                        title: "Pricing",
                        path: "/pricing/"
                    },
                    {
                        title: "Team",
                        path: "/team-collaboration/"
                    },
                    {
                        title: "Business",
                        path: "/business-plan/"
                    },
                    {
                        title: "Enterprise",
                        path: "/enterprise/"
                    },
                    {
                        title: "Consultants",
                        path: "/consultants-agencies/"
                    },
                    {
                        title: "Education",
                        path: "/education-whiteboard/"
                    },
                    {
                        title: "Startups",
                        path: "/startups/"
                    },
                    {
                        title: "NPOs",
                        path: "/npo/"
                    },
                    {
                        title: "Hackathons & Events",
                        path: "/hackathons-and-contests/"
                    }, 
                ],
                viewAllLink: {
                    title: "Contact sales",
                    path: "/contact/sales/"
                }
            }, 
        ]
    }, 
];
export var socialItems = [
    {
        title: "Twitter",
        path: "https://twitter.com/mirohq"
    },
    {
        title: "Facebook",
        path: "https://www.facebook.com/TryMiro"
    },
    {
        title: "LinkedIn",
        path: "https://www.linkedin.com/company/mirohq"
    },
    {
        title: "Instagram",
        path: "https://www.instagram.com/mirohq/"
    },
    {
        title: "Youtube",
        path: "https://www.youtube.com/user/RealtimeBoardEng"
    }, 
];
export var footerLinks = [
    {
        title: "Terms of Service",
        path: "https://miro.com/legal/terms-of-service/"
    },
    {
        title: "Privacy Policy",
        path: "https://miro.com/legal/privacy-policy/"
    }, 
];
export default {
    menu: menu,
    footerLinks: footerLinks,
    socialItems: socialItems
};
